import {
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Copy} from 'kpc';

var _$tmp0 = {
    'text': 'Hello King Desgin!'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$cc(Copy, _$tmp0);
};